<template>
  <span>{{ distance }}</span>
</template>

<script>
import convert from 'convert-units'
import { mapGetters } from 'vuex'

export default {
  name: 'DistanceUnit',
  props: {
    /* always in meters */
    value: {
      type: Number,
      required: true
    },
    best: {
      type: Boolean
    },
    decimals: {
      type: Number,
      default: 0
    },
    unit: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      setting: 'global/setting'
    }),
    metric () {
      return this.setting('km')
    },
    distance () {
      if (this.best) {
        const from = this.metric ? 'm' : 'ft'
        const val = this.metric ? this.value : convert(this.value).from('m').to('ft')
        const best = convert(val).from(from).toBest()
        return this.display(best.val, best.unit)
      } else {
        const to = this.metric ? 'km' : 'mi'
        const length = convert(this.value).from('m').to(to)
        return this.display(length, to)
      }
    }
  },
  methods: {
    display (value, unit) {
      const rounded = this.decimals
        ? parseFloat(value.toFixed(this.decimals))
        : Math.round(value)
      const unitstring = this.unit ? ' ' + unit : ''
      return rounded.toLocaleString() + unitstring
    }
  }
}
</script>
